import { Component } from '@angular/core';
import { GridOptions } from 'ag-grid-community';
import { Service } from '../service';
import { FCToasterService } from '../common/toaster/FCToasterService';
import { EloViewSync } from '../common/models/eloviewsync';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { PopoverCellRendererComponent } from '../popover-cell-renderer/popover-cell-renderer.component';

@Component({
    selector: 'app-eloview-sync',
    templateUrl: './eloview-sync.component.html',
    styleUrls: ['./eloview-sync.component.scss'],
    standalone: false
})
export class EloviewSyncComponent {
  searchFilter: any[];
  txtEloViewSearch: string;
  eloViewData: any[];
  rowData: any[];
  columnDefs: any[];
  gridOptions: GridOptions;
  buildingName: string;
  eloViewSerialnumbers: any;
  checkBuilding: boolean = false;
  eloViewFilterSelectedId: number = 1;
  eloViewFilterSelectedText: string = "Building ID";
  selEloViewSerialnumber: string;
  hasMultipleSerNum: boolean = false;
  eloViewSyncInfo = {} as EloViewSync;
  eloSerialNumberSelectedId: number;
  eloSerialNumberSelectedValue: any;
  eloSerialNumbers: any[];
  closeResult: string;



  constructor(private apiService: Service, private toastr: FCToasterService, private modalService: NgbModal) { }
  ngOnInit(): void {
    this.searchFilter = [{ "id": 1, "name": "Building ID" },
    { "id": 2, "name": "Building Name" },
    { "id": 3, "name": "Unit Number" },
    { "id": 4, "name": "EloView Serial Number" }];
    this.gridOptions = {
      defaultColDef: { filter: true },
      localeText: { noRowsToShow: 'No records found' },
      animateRows: true,
      pagination: true,
      paginationAutoPageSize: true,
      headerHeight: 40,
      rowHeight: 32,
      components: {
        popoverCellRenderer: PopoverCellRendererComponent
      }
    }
    this.eloViewData = [];
    this.rowData = [];
    this.bindGridOnPageLoad();
  }

  bindGridOnPageLoad() {
    this.columnDefs = [
      { headerName: "Source", field: "source", sortable: true, minWidth: 120, flex: 1.2, tooltipField: "source", headerTooltip: "Source" },
      { headerName: "Building Id", field: "buildingId", sortable: true, minWidth: 160, flex: 1.6, resizable: true, tooltipField: "buildingId", headerTooltip: "Building Id" },
      { headerName: "Building Name", field: "buildingName", sortable: true, minWidth: 200, flex: 2, tooltipField: "buildingName", headerTooltip: "Building Name" },
      { headerName: "EloView Serial Number", field: "eloviewSerialnumber", sortable: true, minWidth: 240, flex: 2.4, resizable: true, tooltipField: "eloviewSerialnumber", headerTooltip: "Eloview Serial Number" },
      { headerName: "Device Name", field: "deviceName", sortable: true, minWidth: 200, flex: 2, tooltipField: "deviceName", headerTooltip: "Device Name" },
      { headerName: "", field: "deviceName", cellRenderer: "popoverCellRenderer", filter: false, width: 80, flex: 0 },
      { headerName: "Device Application Type", field: "deviceApplicationType", sortable: true, minWidth: 240, flex: 2.4, tooltipField: "deviceApplicationType", headerTooltip: "Device Application Type" },
      { headerName: "Unit Numbers", field: "unitNumbers", sortable: true, minWidth: 220, flex: 2.2, resizable: true, tooltipField: "unitNumbers", headerTooltip: "Unit Numbers" },
      { headerName: "", field: "unitNumbers", cellRenderer: "popoverCellRenderer", filter: false, width: 80, flex: 0},
      { headerName: "Epal UUID", field: "epalUUID", sortable: true, minWidth: 180, flex: 1.8, resizable: true, tooltipField: "epalUUID", headerTooltip: "Epal UUID" },
    ];
  }
  
  eloViewFilterSelectChanged($event) {
    this.eloViewFilterSelectedId = $event.target.value;
    this.eloViewFilterSelectedText = $event.target.options[$event.target.selectedIndex].text;
    this.txtEloViewSearch = ""; this.hasMultipleSerNum = false; this.clearGrid();
  }

  eloSerNumberChanged($event) {
    this.checkBuilding = false;
    this.selEloViewSerialnumber = $event.target.value;
    this.bindEloViewInfo();
  }

  onEloViewSearch() {
    this.getEloViewInfo();
  }

  eloSerialNumSelectChanged($event) {
    this.eloSerialNumberSelectedValue = $event.target.options[$event.target.selectedIndex].text;
  }
  getEloViewInfo() {
    this.checkBuilding = false;
    if (this.txtEloViewSearch != null && this.txtEloViewSearch != undefined && this.txtEloViewSearch.trim() != "") {
      this.apiService
        .getEloViewInfo(this.txtEloViewSearch, this.eloViewFilterSelectedId)
          .subscribe({
            next: (data: any) => {
              if (data != null) {
                this.eloViewData = data;
                this.eloViewSerialnumbers = [...new Set(this.eloViewData.map(item => item.eloviewSerialnumber))];
                this.hasMultipleSerNum = this.eloViewSerialnumbers.length > 1 ? true : false;
                this.selEloViewSerialnumber = this.eloViewSerialnumbers[0];
                this.bindEloViewInfo();
              }
              else {
                this.eloViewData = [];
                this.eloViewSerialnumbers = [];
                this.hasMultipleSerNum = false;
                this.rowData = [];
                this.toastr.showError(this.eloViewFilterSelectedText + " " + this.txtEloViewSearch + " not Found");
              }
            },
            error: (error: any) => {
              const errMsg = error?.error?.description || error?.message || "An error occurred while fetching EloView info";
              this.toastr.showError(errMsg);
            }
          });
    }
    else {
      this.toastr.showError("Please enter " + this.eloViewFilterSelectedText);
    }
  }
  bindEloViewInfo() {
    this.buildingName = "";
    this.rowData = this.eloViewData.filter(x => x.eloviewSerialnumber == this.selEloViewSerialnumber);
    if (this.rowData.length > 0) {
      this.buildingName = this.rowData[0].buildingName;
    }
  }

  resetFilters() {
    this.eloViewFilterSelectedId = 1; this.txtEloViewSearch = ""; this.hasMultipleSerNum = false;
    this.clearGrid(); this.eloViewFilterSelectedText = "BuildingID";
    this.eloViewData = []; this.eloViewSerialnumbers = [];
  }

  clearGrid() {
    this.buildingName = "";
    this.rowData = [];
    this.checkBuilding = false;
  }

  SyncEloViewInfo() {
    if (this.rowData.length >= 2 && this.rowData[0].source == "FC" && this.rowData[1].source == "EloView") {
    this.eloViewSyncInfo.buildingId = this.rowData[0].buildingId;
    this.eloViewSyncInfo.epalUUID = this.rowData[0].epalUUID;
    this.eloViewSyncInfo.deviceApplicationType = this.rowData[0].deviceApplicationType;
      this.eloViewSyncInfo.eloviewSerialNumber = this.rowData[0].eloviewSerialnumber;
      this.eloViewSyncInfo.fcDeviceName = this.rowData[0].deviceName;
      this.eloViewSyncInfo.eloDeviceName = this.rowData[1].deviceName;
    if (this.checkBuilding) {
      this.apiService
        .syncEloViewInfo(this.eloViewSyncInfo)
        .subscribe({
          next: (data: any) => {
            if (data) {
              this.toastr.showSuccess("EloView Sync Completed Successfully !!");
              this.getEloViewInfo();
              this.checkBuilding = false;
            }
            else {
              this.toastr.showError("EloView Sync Failed !!");
            }
          },
          error: (error: any) => {
            const errMsg = error?.error?.description || error?.message || "An error occurred during EloView Sync";
            this.toastr.showError(errMsg);
          }
        });
    }
    else {
      this.toastr.showError("Please select the building to proceed");
    }
  }
    else {
      this.toastr.showError("The device has not yet commissioned to Elo. Please proceed with ePAL commissioning.");
    }
  }
}

